import { NavLink as Link } from 'react-router-dom'
import styled from 'styled-components'

interface NavLinkProps {
  color?: string;
}

export const NavLink = styled(Link)<NavLinkProps>`
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 40%;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.color || 'inherit'};
`
export const NavLinkExternal = styled(NavLink)`
  color: #005EB8;
  &.active {
    color: #FFFFFF;
    border-radius: 8px;
    border: 1px solid white;
    background: #005EB8;
    cursor: pointer;
  }
`
export const NavLinkAutenticated = styled(NavLink)`
  color: #FFFFFF;
  &.active {
    color: #09325F;
    border-radius: 8px;
    border: 1px solid #F0B323;
    background: #F0B323;
    cursor: pointer;
  }
`
export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  margin-right: -24px;
  @media screen and (max-width: 768px) {
    display: none;
  }
`
export const NavBtn = styled.nav`
  display: flex;
  align-items: center;
  
  @media screen and (max-width: 768px) {
    display: none;
  }
`
interface NavItemProps {
  color?: string;
}

export const NavItem = styled.nav<NavItemProps>`
  display: flex;
  align-items: center;
  margin-right: 24px;
  color: ${props => props.color || 'inherit'};
  @media screen and (max-width: 768px) {
   display: none;
  }
`
export const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 3rem;
  z-index: 12;
`
export const NavExternal = styled(Nav)`
  background: #FFFFFF;
  @media screen and (max-width: 768px) {
   display: none;
  }
`
export const NavAutenticated = styled(Nav)`
  background: #005EB8;
`
export const NavBtnLink = styled(Link)`
  border-radius: 4px;
  background: #146BBE;
  padding: 10px 22px;
  color: white;
  outline: none;
  border: none;
  cursor: pointer;
  /*transition: all 0.2s ease-in-out;*/
  text-decoration: none;
  margin-left: 14px;
  font-weight:bold;
  font-size: 20px;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: white;
    color: #005EB8;
  }
`